/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'resource/happiness': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M10 0C4.477 0 0 4.478 0 10s4.477 10 10 10 10-4.478 10-10S15.523 0 10 0zm0 16c-3.789 0-5-3-5-3h10s-1.211 3-5 3zm5-4H5L3 8l7-4 7 4-2 4z"/><circle pid="1" cx="10" cy="9" r="1"/>'
  }
})
